import { EAspectRatios } from '@/api/schema';

interface ITemplateConfig {
  templateFolderPath: string;
  appNameBackgroundColor: string;
}

interface IAspectCustomization {
  templateImageWidth: number;
  templateImageHeight: number;
  streamerImageWidth: number;
  streamerImageHeight: number;
  nicknameMaxWidth: number;
  nicknameBottomPosition: number;
  appNameBottomPosition: number;
}

export interface IThumbnailConfig extends IAspectCustomization {
  templateImageUrl: string;
  appNameBackgroundColor: string;
}

export enum ETemplateValues {
  TEMPLATE_1 = 'TEMPLATE_1',
  TEMPLATE_2 = 'TEMPLATE_2',
  TEMPLATE_3 = 'TEMPLATE_3',
  TEMPLATE_4 = 'TEMPLATE_4'
}

const mapImageAspectToFileName = {
  [EAspectRatios.FOUR_THREE]: '4_3',
  [EAspectRatios.THREE_FOUR]: '3_4',
  [EAspectRatios.ONE_ONE]: '1_1',
  [EAspectRatios.TWO_THREE]: '2_3',
  [EAspectRatios.SIXTEEN_NINE]: '16_9'
};

const ASPECT_RATIO_CUSTOMIZATIONS: Record<EAspectRatios, IAspectCustomization> =
  {
    [EAspectRatios.ONE_ONE]: {
      templateImageWidth: 800,
      templateImageHeight: 800,
      streamerImageWidth: 424,
      streamerImageHeight: 574,
      nicknameMaxWidth: 380,
      nicknameBottomPosition: 190,
      appNameBottomPosition: 44
    },
    [EAspectRatios.TWO_THREE]: {
      templateImageWidth: 534,
      templateImageHeight: 800,
      streamerImageWidth: 322,
      streamerImageHeight: 526,
      nicknameMaxWidth: 340,
      nicknameBottomPosition: 200,
      appNameBottomPosition: 60
    },
    [EAspectRatios.THREE_FOUR]: {
      templateImageWidth: 600,
      templateImageHeight: 800,
      streamerImageWidth: 360,
      streamerImageHeight: 578,
      nicknameMaxWidth: 340,
      nicknameBottomPosition: 180,
      appNameBottomPosition: 44
    },
    [EAspectRatios.FOUR_THREE]: {
      templateImageWidth: 800,
      templateImageHeight: 600,
      streamerImageWidth: 350,
      streamerImageHeight: 500,
      nicknameMaxWidth: 380,
      nicknameBottomPosition: 70,
      appNameBottomPosition: -50
    },
    [EAspectRatios.SIXTEEN_NINE]: {
      templateImageWidth: 800,
      templateImageHeight: 450,
      streamerImageWidth: 392,
      streamerImageHeight: 450,
      nicknameMaxWidth: 340,
      nicknameBottomPosition: 70,
      appNameBottomPosition: -36
    }
  };

const TEMPLATE_CONFIGS: Record<ETemplateValues, ITemplateConfig> = {
  [ETemplateValues.TEMPLATE_1]: {
    templateFolderPath: '/images/thumbnail/streamers/templates/1',
    appNameBackgroundColor: '#3070f6'
  },
  [ETemplateValues.TEMPLATE_2]: {
    templateFolderPath: '/images/thumbnail/streamers/templates/2',
    appNameBackgroundColor: '#F31044'
  },
  [ETemplateValues.TEMPLATE_3]: {
    templateFolderPath: '/images/thumbnail/streamers/templates/3',
    appNameBackgroundColor: '#41CC18'
  },
  [ETemplateValues.TEMPLATE_4]: {
    templateFolderPath: '/images/thumbnail/streamers/templates/4',
    appNameBackgroundColor: '#FFA527'
  }
};

export function getThumbnailConfig(
  template: ETemplateValues,
  aspectRatio: EAspectRatios
): IThumbnailConfig {
  const aspectConfig = ASPECT_RATIO_CUSTOMIZATIONS[aspectRatio];
  const templateConfig = TEMPLATE_CONFIGS[template];

  if (!aspectConfig) {
    throw new Error(`Configuration for aspect ratio ${aspectRatio} not found`);
  }

  if (!templateConfig) {
    throw new Error(`Configuration for template ${template} not found`);
  }

  return {
    ...aspectConfig,
    templateImageUrl: `${templateConfig.templateFolderPath}/${template}-${mapImageAspectToFileName[aspectRatio]}.png`,
    appNameBackgroundColor: templateConfig.appNameBackgroundColor
  };
}
